import { render, staticRenderFns } from "./VuetifyDataIterator.vue?vue&type=template&id=40a6759a&scoped=true"
import script from "./VuetifyDataIterator.vue?vue&type=script&lang=js"
export * from "./VuetifyDataIterator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6759a",
  null
  
)

export default component.exports